<template>
  <div>
    <input
      @input="
        handleModifierSelect($event, {
          ...modifier,
          modifier_group: modifierGroup.modifier_group,
        })
      "
      type="checkbox"
      :id="`${modifierGroup.modifier_group}${modifier.upc}`"
      :checked="checked"
      :disabled="!checked && maxedOut"
      :value="modifier"
    />
    <!-- checked attribute is used for init only -->
    <label
      :class="sm && 'font-size-sm'"
      :for="`${modifierGroup.modifier_group}${modifier.upc}`"
      >{{ modifier.name }}</label
    >
  </div>
</template>

<script>
export default {
  name: "CheckboxInput",
  computed: {
    checked() {
      return this.modifiers.some(
        (mod) =>
          mod.upc === this.modifier.upc &&
          mod.modifier_group === this.modifierGroup.modifier_group
      );
    },
    maxedOut() {
      const totalCheckedInGroup = this.countCheckedModifiers(
        this.modifierGroup
      );
      return totalCheckedInGroup === this.modifierGroup.max_allowed;
    },
  },
  props: {
    countCheckedModifiers: Function,
    handleModifierSelect: Function,
    modifier: Object,
    modifiers: Array,
    modifierGroup: Object,
    sm: Boolean,
  },
};
</script>

<style scoped>
input[type="checkbox"],
input[type="checkbox"] + label {
  cursor: pointer;
}

input[type="checkbox"] {
  margin: 0;
  opacity: 0;
  padding: 0;
  width: 20px;
}

input[type="checkbox"] + label {
  background: url(~@/assets/checkbox/xs/ic-checkbox-modifier-inactive.svg)
    no-repeat;
  background-position: 0 0;
  display: inline-block;
  line-height: 20px;
  margin-left: -20px;
  padding: 0 0 0 36px;
}

input[type="checkbox"]:checked + label {
  background: url(~@/assets/checkbox/xs/ic-checkbox-modifier-active.svg)
    no-repeat;
}

@media (min-width: 668px) {
  input[type="checkbox"] + label {
    background: url(~@/assets/checkbox/ic-checkbox-modifier-inactive.svg)
      no-repeat;
    line-height: 33px;
  }
  input[type="checkbox"]:checked + label {
    background: url(~@/assets/checkbox/ic-checkbox-modifier-active.svg)
      no-repeat;
  }
}
</style>
